require('./bootstrap');


let pdfs = [];
let renderedPdfs = new Map();

window.addEventListener('load', async () => {
    document.querySelectorAll('img').forEach(img => {
        img.addEventListener('contextmenu', (event) => {
           event.preventDefault();
           return false;
        });
    })

    let images = document.querySelectorAll('img[data-image]');

    if (images.length > 0) {
        await generateImages((progress) => {
            window.dispatchEvent(new CustomEvent('loading-progress', {
                detail: {
                    event: 'progress',
                    data: progress
                }
            }))
        });

        window.dispatchEvent(new CustomEvent('loading-progress', {
            detail: {
                event: 'type-change',
                data: 'Videos'
            }
        }))

        await loadVideos((progress) => {
            window.dispatchEvent(new CustomEvent('loading-progress', {
                detail: {
                    event: 'progress',
                    data: progress
                }
            }))
        });
    }

    let delayedImages = document.querySelectorAll('img[data-src]');

    if (delayedImages.length > 0) {
        let loadedCount = 0;
        let successfulCount = 0;

        await Promise.all(delayedImages.values().map(async (img) => {
            let loaded = await loadImage(img, img.dataset.src);

            if (loaded) {
                img.removeAttribute('data-src');
                successfulCount++;
            } else {
                img.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
                let failedElement = document.createElement('div');
                failedElement.classList.add('w-full', 'h-full', 'flex', 'items-center', 'justify-center', 'text-white');
                failedElement.innerHTML = '<p class="p-12 text-center">This content cannot currently be securely loaded – please try again later. If the issue persists, please contact <a href="mailto:technical@i2ic.com">technical@i2ic.com</a></p>';
                img.parentElement.replaceChild(failedElement, img);
            }

            loadedCount++;
            window.dispatchEvent(new CustomEvent('loading-progress', {
                detail: {
                    event: 'progress',
                    data: (loadedCount / delayedImages.length) * 100
                }
            }))

        }))

        if (successfulCount < loadedCount) {
            document.querySelectorAll('.image-download-button').forEach((element) => {
                element.remove();
            });
        }
    }

    window.dispatchEvent(new CustomEvent('loading-progress', {
        detail: {
            event: 'done'
        }
    }))

    if (window.pdfjsLib && window.pdfs) {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.6.347/pdf.worker.min.js';
        pdfs = JSON.parse(atob(window.pdfs));
    }
});

async function generateImages(progressUpdate) {
    let canvas = document.createElement('canvas');
    let context = canvas.getContext('2d');
    let images = document.querySelectorAll('img[data-image]');

    for (let i = 0; i < images.length; i++) {
        let imgElement = document.createElement('img');
        imgElement.crossOrigin = 'anonymous';
        await loadImage(imgElement, images[i].dataset.image);
        images[i].removeAttribute('data-image');
        canvas.width = imgElement.width;
        canvas.height = imgElement.height;

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(imgElement, 0, 0);

        // Generic watermark (e.g. "Property of AGC Studios") — matches the
        // historic burn-in style: centred, rotated -45deg, white 30%.
        if (window.genericWm) {
            context.save();
            context.translate(canvas.width / 2, canvas.height / 2);
            context.rotate(-45 * Math.PI / 180);
            context.font = `${(canvas.width > canvas.height ? canvas.width : canvas.height) * 0.04}px Arial`;
            context.fillStyle = 'rgba(128,128,128,0.4)';
            context.strokeStyle = 'black';
            context.strokeWidth = 2;
            context.textAlign = "center";
            context.textBaseline = "middle";
            context.fillText(`${atob(window.genericWm)}`, 0, 0);
            context.restore();
        }

        // Per-user watermark (email) — rotated -30deg, white 15%.
        if (window.wm) {
            context.save();
            context.translate(canvas.width / 2, canvas.height / 2);
            context.rotate(-30 * Math.PI / 180);
            context.font = `${canvas.width * 0.045}px Arial`;
            context.fillStyle = 'rgba(128,128,128,0.4)';
            context.strokeStyle = 'black';
            context.strokeWidth = 2;
            context.textAlign = "center";
            context.textBaseline = "middle";
            context.fillText(`${atob(window.wm)}`, 0, 0);
            context.restore();
        }

        images[i].src = canvas.toDataURL("image/jpeg", 0.9);

        if (progressUpdate) {
            progressUpdate((i + 1) / images.length * 100);
        }
    }
}

function loadImage(element, src) {
    return new Promise(resolve => {
        element.addEventListener('load', () => resolve(true), {once: true});
        element.addEventListener('error', () => resolve(false), {once: true});
        element.src = src;
    });
}

async function loadVideos(progressUpdate) {
    let frames = document.querySelectorAll('iframe[data-src]');

    for(let i = 0; i < frames.length; i++) {
        await loadIframe(frames[i], frames[i].dataset.src);

        if (progressUpdate) {
            progressUpdate((i + 1) / frames.length * 100);
        }
    }
}

function loadIframe(iframe, src) {
    return new Promise(resolve => {
        iframe.addEventListener('load', resolve, {once: true});
        iframe.src = src;
    });
}

async function generatePdf(index, filename) {
    window.dispatchEvent(new CustomEvent('pdf-rendering', {
        detail: index
    }));

    let canvas = document.createElement('canvas');
    let context = canvas.getContext('2d');

    const bytes = await fetch(pdfs[index]).then(res => res.arrayBuffer());
    const pdf = await window.pdfjsLib.getDocument(bytes).promise;
    const newDoc = await window.PDFLib.PDFDocument.create();

    for (let j = 1; j <= pdf.numPages; j++) {
        let page = await pdf.getPage(j);
        let viewPort = getScaledViewport(1000, page);
        canvas.height = viewPort.height;
        canvas.width = viewPort.width;

        let renderContext = {
            canvasContext: context,
            viewport: viewPort
        };

        await page.render(renderContext).promise;

        context.save();
        context.textAlign = "center";
        context.textBaseline = "middle";
        context.fillStyle = 'rgba(0, 0, 0, 0.15)';
        context.font = 'bold 100px Arial';
        context.translate(canvas.width / 2, canvas.height / 2);
        context.rotate(-55 * Math.PI / 180);
        context.fillText(atob(window.wm), 0, 0);
        context.restore();

        const docPage = newDoc.addPage([canvas.width, canvas.height]);
        const image = await newDoc.embedJpg(canvas.toDataURL('image/jpeg', 95));
        docPage.drawImage(image, {
            x: 0,
            y: 0,
            width: canvas.width,
            height: canvas.height
        });
    }

    const pdfBytes = await newDoc.saveAsBase64({dataUri: true});

    renderedPdfs.set(index, pdfBytes);
    pdf.destroy();

    const link = document.createElement('a');
    link.href = renderedPdfs.get(index);
    link.download = filename;
    link.click();

    window.dispatchEvent(new CustomEvent('pdf-rendered', {
        detail: index
    }));
}

window.downloadRenderedPdf = async (index, filename) => {
    if (renderedPdfs.has(index)) {
        const link = document.createElement('a');
        link.href = renderedPdfs.get(index);
        link.download = filename;
        link.click();
    } else {
        await generatePdf(index, filename).then();
    }
}

function getScaledViewport(width, page) {
    let viewport = page.getViewport({ scale: 1, });
    let scale = width / viewport.width;
    return page.getViewport({ scale: scale, });
}


document.querySelectorAll('.image-download-button').forEach((element) => {
    element.addEventListener('click', async () => {
        let images = document.querySelectorAll('.image-download-target');
        if (images.length > 0) {

            window.dispatchEvent(new CustomEvent('loading-progress', {
                detail: {
                    event: 'type-change',
                    data: 'Generated PDF'
                }
            }));

            const newDoc = await window.PDFLib.PDFDocument.create();
            let holdingCanvas = document.createElement('canvas');
            let holdingContext = holdingCanvas.getContext('2d');

            for (let i = 0; i < images.length; i++) {
                window.dispatchEvent(new CustomEvent('loading-progress', {
                    detail: {
                        event: 'progress',
                        data: ((i + 1) / images.length) * 100
                    }
                }));
                await new Promise(resolve => setTimeout(resolve, 1));

                holdingCanvas.width = images[i].naturalWidth;
                holdingCanvas.height = images[i].naturalHeight;
                holdingContext.drawImage(images[i], 0, 0);

                let image = await newDoc.embedJpg(holdingCanvas.toDataURL('image/jpeg', 95));
                const docPage = newDoc.addPage([image.width, image.height]);
                docPage.drawImage(image, {
                    x: 0,
                    y: 0,
                    width: image.width,
                    height: image.height
                });
            }

            const pdfBytes = await newDoc.saveAsBase64({dataUri: true});
            const link = document.createElement('a');
            link.href = pdfBytes;
            link.download = element.dataset.filename + '.pdf';

            window.dispatchEvent(new CustomEvent('loading-progress', {
                detail: {
                    event: 'done'
                }
            }));

            link.click();
        }
    });
});
